import Layout from '@/layout/layout'

const platQuotationTrendRouter = {
    path: '/platQuotationTrend',
    component: Layout,
    redirect: 'noRedirect',
    name: '平台报价趋势',
    children: [
        {
            path: 'analysisModel',
            component: () => import('@/views/platQuotationTrend/analysisModel/index'),
            name: '分析机型管理',
            meta: { title: '分析机型管理', noCache: true }
        },
        {
            path: 'quoteTrend',
            component: () => import('@/views/platQuotationTrend/quoteTrend/index'),
            name: '查询报价走势',
            meta: { title: '查询报价走势', noCache: true }
        },
       
    ]
}

export default platQuotationTrendRouter